import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function BrokenHeart({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>BrokenHeart</title>
      <path
        d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.6708 6.33541C12.8561 5.96493 12.7059 5.51442 12.3354 5.32918C11.9649 5.14394 11.5144 5.2941 11.3292 5.66459L12.6708 6.33541ZM10 9.99995L9.32918 9.66454C9.22744 9.86801 9.22356 10.1067 9.31861 10.3133C9.41367 10.52 9.59739 10.6724 9.81809 10.7276L10 9.99995ZM14 11L14.624 11.416C14.7593 11.2131 14.7875 10.957 14.6995 10.7296C14.6116 10.5021 14.4185 10.3316 14.1819 10.2724L14 11ZM11.376 13.584C11.1462 13.9286 11.2393 14.3943 11.584 14.624C11.9286 14.8538 12.3943 14.7607 12.624 14.416L11.376 13.584ZM11.3292 5.66459L9.32918 9.66454L10.6708 10.3354L12.6708 6.33541L11.3292 5.66459ZM9.81809 10.7276L13.8181 11.7276L14.1819 10.2724L10.1819 9.27235L9.81809 10.7276ZM13.376 10.584L11.376 13.584L12.624 14.416L14.624 11.416L13.376 10.584Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
